import { apiClient } from "../config";

async function adminObservationReview(observationId: number, body: any) {
  const res = await apiClient.put(`/admin/qa/review/${observationId}`, body);
  return res.data;
}

export default adminObservationReview;
